import React from "react";
import PropTypes from "prop-types";

const ConnectEnabled = (props) => {
  const { className, style } = props;
  return (
    <svg
      className={className}
      style={style}
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 15.5502C15.0311 15.5502 14.3133 15.8815 13.7644 16.4006L6.23833 11.8173C6.29111 11.5633 6.33333 11.3092 6.33333 11.0442C6.33333 10.7791 6.29111 10.5251 6.23833 10.2711L13.68 5.73193C14.25 6.28414 14.9994 6.62651 15.8333 6.62651C17.5856 6.62651 19 5.14659 19 3.31325C19 1.47992 17.5856 0 15.8333 0C14.0811 0 12.6667 1.47992 12.6667 3.31325C12.6667 3.57831 12.7089 3.83233 12.7617 4.08635L5.32 8.6255C4.75 8.07329 4.00056 7.73092 3.16667 7.73092C1.41444 7.73092 0 9.21084 0 11.0442C0 12.8775 1.41444 14.3574 3.16667 14.3574C4.00056 14.3574 4.75 14.0151 5.32 13.4629L12.8356 18.0572C12.7828 18.2892 12.7511 18.5321 12.7511 18.7751C12.7511 20.5532 14.1339 22 15.8333 22C17.5328 22 18.9156 20.5532 18.9156 18.7751C18.9156 16.997 17.5328 15.5502 15.8333 15.5502Z"
        fill="#4871F0"
      />
    </svg>
  );
};

ConnectEnabled.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};

ConnectEnabled.defaultProps = {
  className: undefined,
  style: undefined,
};

export default ConnectEnabled;
